<h2 mat-dialog-title>
  <mat-icon svgIcon="sell_outlined"></mat-icon>
  Konverter til flådebilsbrik
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
@let idTagDataResult = idTagData();
@if (idTagDataResult) {
  @let idTag = idTagDataResult.idTag;
  @let departments = idTagDataResult.departments;
  @let accessGroups = idTagDataResult.accessGroups;

  <form [formGroup]="convertToFleetIdTagForm" (ngSubmit)="saveConvertToFleetIdTag()">
    <mat-dialog-content class="department-selector">
      @if (!wasSaved) {
        <div mat-dialog-content class="department-selector">
          <div class="form-row">
            <ok-feedback-info>
              <div>
                Brikken er lige nu tilknyttet bruger <span class="bold">{{ idTag.description }}</span> og afdeling
                <span class="bold">{{ idTag.chargingUserDepartmentName }}</span> under organisationen
                <span class="bold">{{ idTag.organizationName }}</span>
              </div>
            </ok-feedback-info>
          </div>
          <div class="form-row">
            <p>Konverter brikken til flådebilsbrik under nedenstående afdeling</p>
            <mat-form-field>
              <mat-label>Vælg afdeling</mat-label>
              <mat-select formControlName="selectedDepartment" okCustomDropDownArrowDirective>
                @for (department of departments; track department) {
                  <mat-option [value]="department">
                    {{ department.name }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix></mat-icon>
              <mat-hint class="text-warning"
                >Efter konvertering af brikken til flådebilsbrik, vil ALT forbrug bagud og fremad blive registreret med afdelingens
                kontonr.</mat-hint
              >
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="mdc-textarea-fix">
              <mat-label>Adgangsgrupper</mat-label>
              <mat-select formControlName="selectedAccessGroups" multiple [compareWith]="compareObjects" okCustomDropDownArrowDirective>
                <mat-select-trigger>
                  @if (convertToFleetIdTagForm.controls.selectedAccessGroups.value.length > 0) {
                    @let selectedAccessGroupsValue = getFirstAccessGroupName();
                    {{ selectedAccessGroupsValue }}
                  }
                  @if (convertToFleetIdTagForm.controls.selectedAccessGroups.value.length > 1) {
                    <span class="example-additional-selection">
                      (+{{ convertToFleetIdTagForm.controls.selectedAccessGroups.value.length - 1 }}
                      {{ convertToFleetIdTagForm.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
                    </span>
                  }
                </mat-select-trigger>
                @for (accessGroup of accessGroups; track accessGroup.identifier) {
                  <mat-option [value]="accessGroup.identifier">{{ accessGroup.name }}</mat-option>
                }
              </mat-select>
              <mat-icon matSuffix></mat-icon>
            </mat-form-field>
          </div>
          <div class="form-row">
            <div>
              <adm-g4-agreement-number [control]="convertToFleetIdTagForm.controls.agreementNumber" />
              <mat-hint class="tiny-text">
                Indtastet aftalenr bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
              </mat-hint>
            </div>
          </div>
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <button
        class="actions__button"
        type="submit"
        [disabled]="saving() || !convertToFleetIdTagForm.valid || wasSaved"
        [class.spinner]="saving()"
        mat-flat-button
        color="primary">
        Gem
      </button>
    </mat-dialog-actions>
  </form>
}
